
import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container, Button, Dropdown } from 'react-bootstrap';
import { FaLink, FaUserCircle, FaCreditCard, FaBars, FaBell } from 'react-icons/fa';
import { MdLogout } from 'react-icons/md';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import userlogo from '../../assets/images/profile.png'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify';
import { logoutTodo } from '../../redux/slice/Logout';
import { notificationList } from '../../redux/slice/NotificationList';
import adLogo from '../../../src/assets/images/logo_white_aduleek.png';

const PrivateNavbar = ({ onMenuClick, dashboard, userBioLink }) => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const notifications = useSelector((state) => state?.notificationList?.data) || [];

  const logout = () => {
    dispatch(logoutTodo()).then((res) => logout_res(res.payload))
  };

  const logout_res = (res) => {
    if (res?.status === 200) {
      toast.success(res?.data?.message, { position: "bottom-right" })
      localStorage.clear();
      navigate('/home');
    } else {
      toast.error(res?.data?.message, { position: "bottom-right" })
    }
  }

  const [profilePhoto, setProfilePhoto] = useState(getStorageItem('profile_photo'));
  const [title, setTitle] = useState(getStorageItem('title'));
  const [name, setName] = useState(getStorageItem('name'));

  // Helper to safely get items from localStorage
  function getStorageItem(key) {
    const item = localStorage.getItem(key);
    return item && item !== 'undefined' && item !== 'null' ? item : null;
  }

  useEffect(() => {
    // Function to update state from localStorage
    const handleUserDataUpdate = () => {
      setProfilePhoto(getStorageItem('profile_photo'));
      setTitle(getStorageItem('title'));
      setName(getStorageItem('name'));
    };

    // Listen for the custom event
    window.addEventListener('userDataUpdated', handleUserDataUpdate);

    // Also listen for storage events (for cross-tab updates, though not strictly required for this task)
    window.addEventListener('storage', handleUserDataUpdate);

    return () => {
      window.removeEventListener('userDataUpdated', handleUserDataUpdate);
      window.removeEventListener('storage', handleUserDataUpdate);
    };
  }, []);

  useEffect(() => {
    dispatch(notificationList({ navigate }));
  }, [dispatch, navigate, location.pathname]);

  const renderNotificationDropdown = (menuClassName = '') => (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="link"
        className="notification-dropdown-toggle"
        id="notification-dropdown"
        style={{
          color: 'white',
          textDecoration: 'none',
          padding: '0.25rem 0.5rem',
          display: 'flex',
          alignItems: 'center',
          border: 'none',
          background: 'transparent',
          position: 'relative'
        }}
      >
        <FaBell size={18} />
        {notifications.length > 0 && (
          <span className="notification-badge">{notifications.length > 9 ? '9+' : notifications.length}</span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className={`notification_drop ${menuClassName}`} align="end">
        <Dropdown.ItemText className="notification-drop-header">
          Notifications
        </Dropdown.ItemText>
        <Dropdown.Divider />
        {notifications.length ? (
          <div className="notification-list">
            {notifications.map((item) => (
              <div key={item._id} className="notification-item">
                <div className="notification-title">{item.title}</div>
                <div className="notification-desc">{item.desc}</div>
              </div>
            ))}
          </div>
        ) : (
          <Dropdown.ItemText className="notification-empty">
            No notifications
          </Dropdown.ItemText>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );

  return (
    <>
      <Navbar
        expand="xl"
        fixed="top"
        className="custom-navbar"
        expanded={expanded}
      >
        <Container fluid>
          {/* Left Section: Brand Name and Sidebar Icon */}
          <div className="d-flex align-items-center flex-nowrap" style={{ maxWidth: 'calc(100vw - 60px)' }}>
            {userBioLink ? "" : <Button
              variant="link"
              className="sidebar-toggle-btn d-xl-none p-0 me-2"
              onClick={onMenuClick}
              style={{
                color: 'white',
                textDecoration: 'none'
              }}
            >
              <FaBars size={20} />
            </Button>}
            <Navbar.Brand href="/" className="brand mb-0 d-flex align-items-center">
              {/* <FaLink className="brand-icon" /> */}
              <img src={adLogo} alt="" height={'30px'} className='brand-logo mb-1' />
              <h5 className="brand-text mb-0 d-inline-block" style={{ fontSize: '18px' }}>AD1&nbsp;&nbsp;&nbsp;Bio Page + Short Link</h5>

            </Navbar.Brand>

          </div>

          {/* <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        /> */}
          <div className='d-flex align-items-center gap-1 d-xl-none'>
            {dashboard ? <Link to='/dashboard' className="dashboard-link mt-1"><h5 className='ms-3 btn btn-outline-secondary dashboard-btn' style={{ color: 'white', marginBottom: '0' }}>Dashboard</h5></Link> : ''}
            {renderNotificationDropdown('mt-2')}
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="link"
                className="profile-dropdown-toggle"
                style={{
                  color: 'white',
                  textDecoration: 'none',
                  padding: '0',
                  display: 'flex',
                  alignItems: 'center',
                  border: 'none',
                  background: 'transparent'
                }}
              >
                <div style={{ width: '28px', height: '28px' }} className='mb-1'>
                  <img src={
                    profilePhoto ? process.env.REACT_APP_BASE_URL + profilePhoto : userlogo} alt="img" className='img-fluid user-img' />

                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="profile_drop" align="end">
                <Dropdown.ItemText className="dropdown-welcome-text">
                  Welcome! { name}
                </Dropdown.ItemText>
                <Dropdown.Divider />
                <Dropdown.Item as="button" onClick={logout} className="dropdown_item">
                  <MdLogout
                    className="me-2"
                    size={20}
                    style={{ color: '#4c4b4bff', verticalAlign: 'middle' }}
                  />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            {/* Right Section: Buy Links Button and Profile Icon */}
            <Nav className="ms-auto align-items-center">
              {/* <Link to="/plans" className="me-3">
              <Button
                variant="warning"
                className="d-flex align-items-center gap-2 buy-links-btn"
                style={{
                  fontWeight: 500
                }}
              >
                <FaCreditCard size={18} />
                <span className="btn-text">Buy Links</span>
              </Button>
            </Link> */}
              {dashboard ? <Link to='/dashboard' className="dashboard-link mt-1 mb-1"><h5 className='mb-1 btn btn-outline-secondary dashboard-btn' size='sm' style={{ color: 'white' }}>Dashboard</h5></Link> : ''}
              {renderNotificationDropdown('mt-2')}
              <Dropdown align="end">
                <Dropdown.Toggle
                  variant="link"
                  className="profile-dropdown-toggle"
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    padding: '0.25rem 0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    border: 'none',
                    background: 'transparent'
                  }}
                >
                  <div style={{ width: '30px', height: '30px' }}>
                    <img src={
                      profilePhoto ? process.env.REACT_APP_BASE_URL + profilePhoto : userlogo} alt="img" className='img-fluid user-img' />
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="profile_drop mt-2" align="end">
                  <Dropdown.ItemText className="dropdown-welcome-text">
                    Welcome! {name}
                  </Dropdown.ItemText>
                  <Dropdown.Divider />
                  <Dropdown.Item as="button" onClick={logout} className="dropdown_item">
                    <MdLogout
                      className="me-2"
                      size={20}
                      style={{ color: '#4c4b4bff', verticalAlign: 'middle' }}
                    />
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <style>{`
      .notification-dropdown-toggle::after {
        display: none !important;
      }
      .notification-badge {
        position: absolute;
        top: 0;
        right: 2px;
        min-width: 16px;
        height: 16px;
        padding: 0 4px;
        border-radius: 999px;
        background: #ef4444;
        color: #fff;
        font-size: 10px;
        line-height: 16px;
        text-align: center;
        font-weight: 600;
      }
      .notification_drop {
        min-width: 280px;
        max-width: min(340px, 90vw);
        padding: 0;
        border: none;
        border-radius: 10px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        overflow: hidden;
      }
      .notification-drop-header {
        font-weight: 600;
        font-size: 14px;
        color: #1f2937;
        padding: 12px 14px 8px;
      }
      .notification-list {
        max-height: 320px;
        overflow-y: auto;
      }
      .notification-item {
        padding: 10px 14px;
        border-top: 1px solid #f1f5f9;
      }
      .notification-item:hover {
        background: #f8fafc;
      }
      .notification-title {
        font-size: 13px;
        font-weight: 600;
        color: #111827;
        margin-bottom: 2px;
      }
      .notification-desc {
        font-size: 12px;
        color: #6b7280;
        line-height: 1.4;
        word-break: break-word;
      }
      .notification-empty {
        padding: 16px 14px;
        font-size: 13px;
        color: #9ca3af;
        text-align: center;
      }
      @media (max-width: 1199px) {
        .custom-navbar {
          padding-left: 0px !important;
          padding-right: 0px !important;
        }
        .custom-navbar .container-fluid {
          flex-wrap: nowrap !important;
        }
        .brand-text {
          font-size: 14px !important;
          // max-width: 160px !important;
          white-space: pre-wrap;
          line-height: 1.2;
        }
        .dashboard-btn {
          font-size: 14px !important;
          padding: 6px 10px !important;
          margin-left: 8px !important;
        }
      }
      @media (max-width: 400px) {
        .brand-logo {
          height: 25px !important;
          margin-top: 5px !important;
        }
        .brand-text {
          font-size: 11px !important;
          // max-width: 120px;
        }
        .sidebar-toggle-btn {
          margin-right: 4px !important;
        }
        .user-img {
          height: 24px !important;
          width: 24px !important;
                border-radius: 50% !important;
        }
          
      }
    `}</style>
    </>
  );
};

export default PrivateNavbar;
